import { Component } from "@angular/core";
import { FeatureFlagsService } from "src/app/services/feature-flag/feature-flag.service";

@Component({
  selector: 'app-edit-pet-wrapper',
  template: `
    <app-edit-v2 *ngIf="useRebranded"></app-edit-v2>
    <app-edit-my-pet *ngIf="!useRebranded"></app-edit-my-pet>
  `
})
export class EditPetWrapperComponent {
  public useRebranded: boolean;
  
  constructor(private featureFlagService: FeatureFlagsService) {
    this.useRebranded = this.featureFlagService.isEnabled('useRebrandedLayout');
  }
}